import { render, staticRenderFns } from "./headerPrise.vue?vue&type=template&id=525c344e&scoped=true&"
import script from "./headerPrise.vue?vue&type=script&lang=js&"
export * from "./headerPrise.vue?vue&type=script&lang=js&"
import style0 from "./headerPrise.vue?vue&type=style&index=0&id=525c344e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525c344e",
  null
  
)

export default component.exports